<template>
  <AppSheet
    :is-open="store.isOpen && store.mode === 'feedback'"
    mode="fullscreen"
    panel-class="feedback-fullscreen-panel"
    :backdrop-dismiss="false"
    @update:is-open="(v: boolean) => { if (!v) handleDismiss() }"
  >
    <AppContent class="p-0" :scroll-y="true">
      <UnhappyFormStep
        :initial-message="store.prefillMessage ?? undefined"
        @submitted="onCompleted"
        @cancel="onCancel"
      />
    </AppContent>
  </AppSheet>
</template>

<script setup lang="ts">
import AppSheet from '@/components/common/AppSheet.vue'
import AppContent from '@/components/common/AppContent.vue'
import { useFeedbackStore } from '@/stores/feedback';
import UnhappyFormStep from './UnhappyFormStep.vue';

const store = useFeedbackStore();

function onCancel() {
  store.close();
}

function onCompleted() {
  store.close();
}

function handleDismiss() {
  // Back Android / dismissal résiduel = annulation
  if (store.isOpen) {
    store.close();
  }
}
</script>
